import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function QuestionAnswers() {
  var studentsQuestion = [
  {
    id: "headingOne",
    question: "What is AISECT Inter College? How does it work?",
    answer:
      "AISECT Inter College is a premier institution offering Class 11 and 12 education in Science, Commerce, and Arts streams. We focus on academic excellence, discipline, skill development, and holistic growth. Along with regular classroom learning, students receive practical exposure, digital learning support, sports, cultural activities, and career guidance.",
  },
  {
    id: "headingTwo",
    question: "Do students receive regular updates and important notifications?",
    answer:
      "Yes! Students and parents receive timely updates through our mobile app, notice board, and official website. Exam schedules, results, assignments, events, and circulars are regularly published to keep everyone informed.",
  },
  {
    id: "headingThree",
    question: "Does AISECT Inter College support preparation for competitive exams?",
    answer:
      "Absolutely. We provide special guidance and support for competitive exams like JEE, NEET, CUET, and other entrance tests. Our experienced faculty ensures students are well-prepared for their future goals.",
  },
  {
    id: "headingFour",
    question: "What facilities are available for students at AISECT Inter College?",
    answer:
      "We provide smart classrooms, well-equipped laboratories, a digital library, sports facilities, career counseling, regular attendance monitoring, and safe campus environment. Our curriculum promotes both academic and personal development.",
  }
  ];
  return (
    <div className="rbt-accordion-style rbt-accordion-01  accordion">
      <div className="accordion">
        {studentsQuestion.map((items, index) => (
          <Accordion
            style={{ border: "20px" }}
            key={index + 1}
            className="accordion-item card"
          >
            <AccordionSummary
              key={index}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id={"panel1a-header" + index}
              className="accordion-header card-header"
              // className="accordion-button"
            >
              <Typography
                // bgcolor="white"
                // className="accordion-header card-header"
                style={{ fontWeight: "bold", fontSize: "16px" }}
                variant="h6"
              >
                {items.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="accordion-body card-body">
              <Typography
                // className="mb--15"
                variant="h6"
                style={{ fontFamily: "sans-serif", fontSize: "14px" }}
              >
                {items.answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </div>
  );
}
